import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  background: ${props => props.theme.colors.white_variant};
  border-radius: 0.8rem;
  height: calc(100vh - 158px);
  gap: 10px;

  .mobile & {
    max-width: calc(100vw - 30px) !important;
    margin: 0 15px;
  }
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;  
  margin-top: 0.8rem;
  width: 90%;
  font-size: 1.6rem;

  .mobile & {
    flex-direction: column;
    align-items: start;  
    font-size: 12px;
    
    > span {
      padding-bottom: 10px;
    }
  }
`;

export const SearchInput = styled.div`
  border: 0.1rem solid ${props => props.theme.colors.grey};
  border-radius: 0.8rem;
  width: 50%;
  height: 1.6rem;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);

  display: flex;
  align-items: center;
  padding: 0 0.1rem;

  #search {
    padding: 0.4rem;
  }

  input {
    border: none;
    width: 100%;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${props => props.theme.colors.dark_grey};
    }
  }
`;

export const ListBody = styled.div`
  width: 100%;
  height: auto;
  max-height: 40rem;
  overflow: auto;
  overflow-x: hidden;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  width: 75%;
  height: 4.6rem;

  img {
    margin-left: 0.8rem;
  }

  span {
    margin-left: 0.8rem;
    font-weight: 400;
  }
`;

export const PDF = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  /* margin-right: 1rem; */
  /* margin-left: 1rem; */  
`;
export const ButtonBox = styled.div`
  width: 100%;
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  gap: 10px;

  .mobile & {
    flex-direction: column;
    margin-bottom: 10px;
  }
`;

export const AnswerTest = styled.button`
  background: ${props => props.theme.colors.primary};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  color: #FFFFFF;
  border: 0px;
  font-size: 1rem;
  padding: .3rem 2rem .3rem 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-around;
  svg{
    margin-right: .5rem;
  }
`;